import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import {
  ContInfoMisionVision,
  ContImgMision,
  CardContainer,
  AnimatedCardTitle,
  AnimatedCardDescription,
  AnimatedCardContentContainer
} from './ModulesTabs.styles';
import '../../globals/services-styles.css';
import IphoneDigital from '../../assets/images/UseCases/modulesTabs/iphone-digital.png';
import Analisis from '../../assets/images/UseCases/modulesTabs/module-analisis.png';
import Score from '../../assets/images/UseCases/modulesTabs/module-score.png';
import Pld from '../../assets/images/UseCases/modulesTabs/module-pld.png';
import Dispersion from '../../assets/images/UseCases/modulesTabs/module-dispersion.png';
import Notifications from '../../assets/images/UseCases/modulesTabs/module-campa-white2.png';
import Cobranza from '../../assets/images/UseCases/modulesTabs/module-cobranza.png';

const buildCardData = (t) => [
  {
    alt: t('Registro de información de clientes con Onboarding digital'),
    ttl: t('Registra nuevos clientes con Onboarding Digital'),
    title: t('Onboarding digital'),
    description: t('Agiliza la integración de nuevos clientes, solicitando información de manera digital y validándola con el método más seguro.'),
    image: IphoneDigital,
  },
  {
    alt: t('Realiza un análisis de crédito de tus clientes'),
    ttl: t('Analiza el historial y el score crediticio de tus clientes'),
    title: t('Análisis de crédito'),
    description: t('Evalúa la capacidad de pago de tus clientes consultando su historial y score crediticio de manera fácil y rápida.'),
    image: Analisis,
  },
  {
    alt: t('Evalúa el comportamiento digital de tus clientes'),
    ttl: t('Obtén el score crediticio de tus clientes'),
    title: t('Score Alternativo'),
    description: t('Obtén la puntuación crediticia de tus clientes por medio de su comportamiento digital.'),
    image: Score,
  },
  {
    alt: t('Prevención de lavado de dinero'),
    ttl: t('Cumple con normativas PLD'),
    title: 'PLD',
    description: t('Cumple con normativas y prevén riesgo de fraude'),
    image: Pld,
  },
  {
    alt: t('Dispersión de recursos a clientes, empleados y proveedores'),
    ttl: t('Controla todas tus dispersiones desde una plataforma'),
    title: t('Dispersión'),
    description: t('Olvídate de la conciliación manual y ten control de todas tus dispersiones.'),
    image: Dispersion,
  },
  {
    alt: t('Configura tu campaña de mensajes para tus clientes'),
    ttl: t('Campaña de mensajes automatizados'),
    title: t('Campaña de notificaciones'),
    description: t('Crea una estrategia de comunicación con tus clientes.'),
    image: Notifications,
  },
  {
    alt: t('Ofrece los mejores medios de pago'),
    ttl: t('Los mejores métodos de pago'),
    title: t('Cobranza'),
    description: t('Los mejores métodos de pago para tu cliente.'),
    image: Cobranza,
  },
];

const ImageContent = ({ hoveredCard }) => {
  const { t } = useTranslation();
  const cardData = buildCardData(t);
  const backgroundImage = cardData[hoveredCard] ? cardData[hoveredCard].image : '';

  return (
    <ContImgMision>
      <img
        id={'ImgeMision'}
        alt={cardData[hoveredCard]?.alt || ''}
        style={{
          opacity: 1,
          transition: 'opacity 0.3s ease',
        }}
        src={backgroundImage}
        title={cardData[hoveredCard]?.ttl || ''}
      />
    </ContImgMision>
  );
};

export const ModulesTabs = () => {
  const { t } = useTranslation();
  const cardData = buildCardData(t);
  const [hoveredCard, setHoveredCard] = useState(0);

  const handleCardHover = (cardNumber) => {
    setHoveredCard(cardNumber);
  };

  useEffect(() => {}, [hoveredCard]);

  return (
    <Grid container spacing={2} id={'GridPrincipal'}>
      <Grid item xs={12} sm={12} md={6} order={{ xs: 1, sm: 1, md: 1 }}>
        <ImageContent hoveredCard={hoveredCard} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} order={{ xs: 2, sm: 2, md: 2 }}>
        <ContInfoMisionVision id={'ContInfoMisionVision'}>
          {cardData.map((card, index) => (
            <CardContainer
              key={index}
              onMouseEnter={() => handleCardHover(index)}
            >
              <AnimatedCardContentContainer isHovered={hoveredCard === index}>
                <AnimatedCardTitle isHovered={hoveredCard === index}>{card.title}</AnimatedCardTitle>
                <AnimatedCardDescription isHovered={hoveredCard === index}>{card.description}</AnimatedCardDescription>
              </AnimatedCardContentContainer>
            </CardContainer>
          ))}
        </ContInfoMisionVision>
      </Grid>
    </Grid>
  );
};
